window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.baseURL = location.origin;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

/* global var */
import {empty,rempty} from 'V2/scripts/helpers/empty'
//import {__,__all} from 'V2/scripts/lang'
import moment from 'V2/scripts/moment'
import inputmask from 'V2/scripts/inputmask'

window.empty = empty;
window.rempty = rempty;
window.moment = moment;
window.inputmask = inputmask;
//window.__ = __;
//window.__all = __all;
/* END global var */

